export default "__VITE_ASSET__CQdtKQwu__"